import { Navigate } from 'react-router';
import { PageHeader } from '@/app/PlaceholderPage';
import { useAuth } from '@/features/auth/AuthContext';
import { EmptyState } from '@/components/ui/Feedback';
import { Card } from '@/components/ui/Card';
import { PelitaIntensiveClassTab } from './PelitaIntensiveClassTab';

export function PelitaMyIntensiveClassPage() {
  const { user } = useAuth();

  // Jika admin mengakses rute ini, alihkan ke manajemen kelas intensif admin
  if (user?.role === 'super_admin') {
    return <Navigate to="/database/kelas-intensif" replace />;
  }

  const individualId = user?.individualId;

  if (!individualId) {
    return (
      <div className="flex flex-col gap-5">
        <PageHeader
          title="Kelas Intensif PELITA SLI"
          description="Rekam jejak evaluasi pembelajaran sesi aktivitas, presensi kehadiran, dan e-sertifikat."
        />
        <Card>
          <EmptyState
            icon="🎓"
            title="Akun belum terhubung dengan data individu"
            description="Silakan hubungi administrator untuk menghubungkan akun Anda dengan data profil PELITA SLI."
          />
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Kelas Intensif PELITA SLI"
        description="Rekam jejak capaian evaluasi pembelajaran sesi materi, presensi kehadiran per sesi, peningkatan kompetensi (gain score), dan unduh e-sertifikat kelulusan."
      />
      <PelitaIntensiveClassTab individualId={individualId} />
    </div>
  );
}
